import { EventEmitter, Injectable } from '@angular/core';
import { Subscription } from 'rxjs';
import { TableColumn } from '../models/table-column';
import { ColumnSelectionListComponent } from '../../components/columns/column-selection-list/column-selection-list.component';
import { ModalService } from './modal.service';
import { TableColumnService } from '../interfaces/table/table-column.service';
import { PopOverService } from './pop-over.service';

@Injectable({
  providedIn: 'root',
})
export class ColumnSelectionModalService {
  private subscriptions: Subscription[] = [];

  constructor(
    private modalService: ModalService,
    private showPopOverService: PopOverService
  ) {}

  /**
   * Show modal to select and order columns of the day table.
   * (maybe good idea to make this for all tables)
   *
   * @param tableColumnService the Service which updates the column state according to selection.
   * @param tableColumns list of selectable columns.
   */
  showColumnSelectionModal(
    tableColumnService: TableColumnService,
    tableColumns: TableColumn[]
  ): void {
    const onCancel = new EventEmitter();
    const onSave = new EventEmitter<TableColumn[]>();

    this.modalService.showModal(ColumnSelectionListComponent, {
      columnsSelection: tableColumns,
      onCancel,
      onSave,
    });

    // exit on cancel
    this.subscriptions.push(
      onCancel.subscribe(() => {
        this.modalService.dismissModal();
        this.subscriptions.forEach((sub) => sub.unsubscribe());
      })
    );

    // exit on save
    this.subscriptions.push(
      onSave.subscribe((newSelection) => {
        this.modalService.dismissModal();
        tableColumnService.showSelectedColumns(newSelection);
        this.subscriptions.forEach((sub) => sub.unsubscribe());
      })
    );
  }

  /**
   * Show popover to select and order columns of the day table.
   * (maybe good idea to make this for all tables)
   *
   * @param tableColumnService the Service which updates the column state according to selection.
   * @param tableColumns list of selectable columns.
   * @param cssClassName name of the css class for popover styling.
   */
  showColumnSelectionPopOver(
    tableColumnService: TableColumnService,
    tableColumns: TableColumn[],
    cssClassName: string
  ): void {
    /* let onCancel = new EventEmitter();
         let onSave = new EventEmitter<TableColumn[]>();

         this.showPopOverService.showPopOver(ColumnSelectionListComponent,{
                 'columnsSelection': tableColumns,
                 'onCancel': onCancel,
                 'onSave': onSave,
             }, cssClassName);

         // exit on cancel
         this.subscriptions.push(onCancel.subscribe(() => {
             this.showPopOverService.dismissPopOver();
             this.subscriptions.forEach(sub => sub.unsubscribe());
         }));

         // exit on save
         this.subscriptions.push(onSave.subscribe(newSelection => {
             this.showPopOverService.dismissPopOver();
             tableColumnService.showSelectedColumns(newSelection);
             this.subscriptions.forEach(sub => sub.unsubscribe());
         }));*/
  }
}
